import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PurchaseOrdersPage } from '../pages/procurement/PurchaseOrdersPage';
import { QuickPoModal } from '../pages/procurement/release-queue/QuickPoModal';
export function ProfilePurchaseOrdersRoute() {
 const location=useLocation(),navigate=useNavigate(); const [revision,setRevision]=useState(0);
 const close=()=>navigate('/purchase-orders',{replace:true,state:null});
 return <><PurchaseOrdersPage key={revision}/><QuickPoModal open={location.state?.action==='create'} onClose={close} onCreated={()=>{setRevision(v=>v+1);close();}}/></>;
}
